import { Region } from "@app/shared/models/region";
import { User } from "@app/shared/models/user";

export class Project {
  uuid:string;
  id: number;
  name?:string;
  clientCode?:string;
  code?:string;
  completedDate?:number;
  createdDate?:number;
  authoriserUUID?:number;
  authoriser?:User;
  projectmanagerUUID?:number;
  projectManager?:User;
  accountManagerUUID?:number;
  accountManager?:User;
  dateLastModified?:number;
  deleteddate?:number;
  descr?:string;
  endDate?:number;
  isMarketingContent?:string;
  locale?:string;
  searchIndex?:string;
  showoffersets?:string;
  showstorepacks?:string;
  startDate?:number;
  statRunTrigger?:number;
  campaignRegions?:Region[];
  pages?:number;
  height?:number;
  width?:number;
  unit?:string;
  outputSize?:string;
  subtypeName?:string;
  masterRegion?:string;
  templateId?:string;
  totalPageCount?:number;
  campaignStages?:any;
  businessBrandTag?:string;
  dateLastSentToStudio?:string;
  fileDelivery?:string;		
  studioPreference?:string;
  authoriserName?:string;
  get inMarket():boolean{
    let aestTime = new Date().toLocaleString("en-US", {timeZone: "Australia/Melbourne"});
    let today = new Date(aestTime).getTime();
    let from = new Date(this.startDate);
    let to = new Date(this.endDate);

    // set this to the start of the day
    from.setHours(0);

    // set this to the end
    to.setHours(23);
    to.setMinutes(59);

    let fromTime = from.getTime();
    let toTime = to.getTime();

    let result = false;

    if(today >= fromTime && today <= toTime) {
      result = true;
    }
    return result;
  }
}


export class ProjectMenuEvent{
  type?:string;
  project?:Project;
}

export const ProjectMenuEventType = {
  EDIT_PROJECT: 'EDIT_PROJECT',
  ADD_PROJECT: 'ADD_PROJECT',
  RETIRE_PROJECT:'RETIRE_PROJECT',
  RESTORE_PROJECT:'RESTORE_PROJECT',
  NOTIFY_TEAMS:'NOTIFY_TEAMS_PROJECT',
  COPY_PROJECT:'COPY_PROJECT',
  SHOW_INFO:'SHOW_PROJECT_INFO',
  GENERATE_CSV:'GENERATE_PROJECT_CSV',
  ARRANGE_PAGES:'ARRANGE_PAGES',
};

export class ProjectSearchCriteria{
  keyword?:string;
}

export class ProjectSetupValues{
  authorisers?:any[];
  documentSubTypes?:any[];
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/project.ts